import { ReactNode } from 'react';
import { withStyles, CheckboxIndicator } from 'vopay';
import styles from './Checkbox.module.scss';

const cn = withStyles(styles);

type CheckboxProps = {
  name: string;
  checked: boolean;
  label: ReactNode;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
};

export default function Checkbox({ name, checked, label, disabled, onChange }: CheckboxProps) {
  return (
    <label htmlFor={name} className={cn('checkbox')}>
      <div>
        <div>
          <CheckboxIndicator checked={checked} />
        </div>
        <input
          id={name}
          name={name}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className={cn('visuallyHidden')}
          disabled={disabled}
        />
        <div>{label}</div>
      </div>
    </label>
  );
}
